// ref: https://gitlab.com/web-apps-dietela/backend/-/merge_requests/244

export const reqContentMonthGroup = async(axios, { type }) => {
  return axios.get('/v1/admin/content-month-group', {
    params: {
      type, // string! = target_harian | materi_harian
    },
  })
}